import { gql } from '@apollo/client';
export const UpdateHolidayAllowanceMutation = gql `
    mutation UpdateHolidayAllowance($siteSetId: InstitutionSetId!, $holidayAllowance: Float!) {
        staffhours {
            settings {
                updateHolidayAllowance(siteSetId: $siteSetId, holidayAllowance: $holidayAllowance)
            }
        }
    }
`;
